import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './components/layout/layout.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';

import { ScrollToTopDirective } from './directives/scroll-to-top.directive';
import { NinjaBannerComponent } from './components/ninja-banner/ninja-banner.component';
import { BulenoxBannerComponent } from './components/bulenox-banner/bulenox-banner.component';
import { ChatbotComponent } from './components/chatbot/chatbot.component';
import { ImageLightboxComponent } from './components/image-lightbox/image-lightbox.component';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    ScrollToTopDirective,
    NinjaBannerComponent,
    BulenoxBannerComponent,
    ChatbotComponent,
    ImageLightboxComponent,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
